import script from "./ApplyQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyQuestions.vue?vue&type=script&setup=true&lang=js"

import "./ApplyQuestions.vue?vue&type=style&index=0&id=554f1dda&lang=scss&scoped=true"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554f1dda"]])

export default __exports__